import {
    Category2,
    Shop,
    Flash,
    NotificationStatus,
    Tag,
    Element4,
    Global,
    CopySuccess,
    Profile2User,
    TicketStar,
    Gift,
    I3Dcube,
    ColorsSquare,
    BagTick,
    PresentionChart,
    Setting2,
    TagUser,
    UserAdd,
    Game,
    Coin,
    Grid2,
    Link1,
    Message,
    Chart1,
    FlashCircle,
    Diamonds,
    Ticket,
    ScanBarcode,
    Receipt21,
    TagRight,
    FavoriteChart,
    Menu,
    Notepad2,
    TextalignLeft,
    Mobile,
    Card,
    Send2,
    CpuSetting,
    Designtools,
    Truck
} from "iconsax-react";
import { RouteItem, UserTypes } from "../../interfaces/routes.interface";

import { ROUTES } from "../../constants/routes";

import AuthGuard from "../../layouts/AuthGuard";
import { lazy } from "react";
import createIconWrapper from "../../components/shared/IconWrapper";
import { ORGANIZATION_TYPE_ENUM } from "../../enums/organization-type.enum";

const OrganizationSettings = lazy(
    () => import("../../../modules/organization/settings")
);
const DeliverySettings = lazy(
    () => import("../../../modules/organization/delivery-settings")
);
const CustomContent = lazy(
    () => import("../../../modules/organization/custom-content")
);
const Haptics = lazy(
    () => import("../../../modules/organization/custom-content/haptics")
);
const OrganizationDashboard = lazy(
    () => import("../../../modules/organization/dashboard")
);
const Stores = lazy(() => import("../../../modules/organization/stores"));
const Form = lazy(() => import("../../../modules/organization/stores/Form"));
const IntegrationForm = lazy(
    () => import("../../../modules/organization/integrations/Form")
);
const GeofenceForm = lazy(
    () => import("../../../modules/organization/geofences/Form")
);
const AiqFlowEvents = lazy(
    () => import("../../../modules/organization/aiq-flow-events")
);
const AiqFlowEventsForm = lazy(
    () => import("../../../modules/organization/aiq-flow-events/Form")
);
const OrganizationSingleAchievementForm = lazy(
    () => import("../../../modules/organization/achievements/single/Form")
);

const OrganizationTieredAchivementForm = lazy(
    () => import("../../../modules/organization/achievements/tiered/Form")
);

const OrganizationAchievements = lazy(
    () => import("../../../modules/organization/achievements")
);
const OrganizationAchievementsCreate = lazy(
    () => import("../../../modules/organization/achievements/Create")
);

const CategoriesForm = lazy(
    () => import("../../../modules/organization/categories/Form")
);
const Categories = lazy(
    () => import("../../../modules/organization/categories")
);
const BrandTagsForm = lazy(
    () => import("../../../modules/organization/brand-tags/Form")
);
const BrandTags = lazy(
    () => import("../../../modules/organization/brand-tags")
);
const Products = lazy(() => import("../../../modules/organization/products"));
const ProductsForm = lazy(
    () => import("../../../modules/organization/products/Form")
);

const BrandHomepage = lazy(
    () => import("../../../modules/organization/brand-homepage")
);

const BrandStores = lazy(
    () => import("../../../modules/organization/brand-store")
);
const BrandStoreForm = lazy(
    () => import("../../../modules/organization/brand-store/Form")
);

const Notifications = lazy(
    () => import("../../../modules/organization/notifications")
);
const Promotions = lazy(
    () => import("../../../modules/organization/promotions")
);
const PromotionForm = lazy(
    () => import("../../../modules/organization/promotions/Form")
);
const PunchcardForm = lazy(
    () => import("../../../modules/organization/punchcards/Form")
);
const RewardForm = lazy(
    () => import("../../../modules/organization/rewards/Form")
);
const Integrations = lazy(
    () => import("../../../modules/organization/integrations")
);
const Geofences = lazy(() => import("../../../modules/organization/geofences"));
const OrganizationManagement = lazy(
    () => import("../../../modules/organization/organization")
);
const Punchcards = lazy(
    () => import("../../../modules/organization/punchcards")
);
const PunchcardDashboard = lazy(
    () => import("../../../modules/organization/punchcards/Dashboard")
);
const Customers = lazy(() => import("../../../modules/organization/customers"));
const Rewards = lazy(() => import("../../../modules/organization/rewards"));
const RewardCategories = lazy(
    () => import("../../../modules/organization/reward-categories")
);
const CustomerProfile = lazy(
    () => import("../../../modules/organization/customers/profile")
);
const Coupons = lazy(() => import("../../../modules/organization/coupons"));
const CouponsForm = lazy(
    () => import("../../../modules/organization/coupons/Form")
);
const ReferralsReport = lazy(
    () => import("../../../modules/organization/reports/ReferralsReport")
);
const AchievementsEarnedReport = lazy(
    () =>
        import("../../../modules/organization/reports/AchievementsEarnedReport")
);
const TenantOrders = lazy(() => import("../../../modules/organization/orders"));

const Games = lazy(() => import("../../../modules/organization/games/games"));
const GamesForm = lazy(
    () => import("../../../modules/organization/games/games/Form")
);

const GamesDashboard = lazy(
    () => import("../../../modules/organization/games/games/Dashboard")
);

const GameEntries = lazy(
    () => import("../../../modules/organization/games/game-entries")
);
const GameEntriesForm = lazy(
    () => import("../../../modules/organization/games/game-entries/Form")
);

const UserRegistrationReport = lazy(
    () => import("../../../modules/organization/reports/UserRegistration")
);

const MicroCurrencies = lazy(
    () => import("../../../modules/organization/micro-currency")
);
const MicroCurrenciesForm = lazy(
    () => import("../../../modules/organization/micro-currency/Form")
);

const DownloadLinks = lazy(
    () => import("../../../modules/organization/download-links")
);
const DownloadLinksForm = lazy(
    () => import("../../../modules/organization/download-links/Form")
);

const InAppQRCodes = lazy(
    () => import("../../../modules/organization/in-app-qr-codes")
);
const InAppQRCodesForm = lazy(
    () => import("../../../modules/organization/in-app-qr-codes/Form")
);

const AppFeedbacks = lazy(
    () => import("../../../modules/organization/app-feedbacks")
);

const TiersPage = lazy(() => import("../../../modules/organization/tiers"));
const TiersFormView = lazy(
    () =>
        import("../../../modules/organization/tiers/index.view").then((m) => ({
            default: m.TiersFormView,
        }))
);
const Sweepstakes = lazy(
    () => import("../../../modules/organization/sweepstakes")
);
const SweepstakesForm = lazy(
    () => import("../../../modules/organization/sweepstakes/Form")
);
const SweepstakesDashboard = lazy(
    () => import("../../../modules/organization/sweepstakes/Dashboard")
);

const CustomTags = lazy(
    () => import("../../../modules/organization/custom-tags")
);
const CustomTagsForm = lazy(
    () => import("../../../modules/organization/custom-tags/Form")
);
const BrandBoosts = lazy(
    () => import("../../../modules/organization/brand-boost")
);

const NotificationsForm = lazy(
    () =>
        import(
            "../../../modules/organization/notifications/SendNotifications/Form"
        )
);

const GiftCardSettings = lazy(
    () => import("../../../modules/organization/gift-card-settings")
);

const Engagement = lazy(
    () => import("../../../modules/organization/engagement")
);
const EngagementForm = lazy(
    () => import("../../../modules/organization/engagement/Form")
);
const EngagementDetail = lazy(
    () => import("../../../modules/organization/engagement/Detail")
);

const userTypes = [UserTypes.user];
const roles = ["Organization Admin", "Manager"] as any;
const orderRoles = ["Organization Admin", "Manager", "Budtender"] as any;

export const overview: RouteItem = {
    name: "My App",
    id: ROUTES.USER.overview.key,
    path: ROUTES.USER.overview.key,
    component: OrganizationDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Category2, { variant: "Linear" }),
    iconActive: createIconWrapper(Category2, { variant: "Bold" }),
};

export const stores: RouteItem = {
    name: "Stores",
    id: ROUTES.USER.stores.key,
    path: ROUTES.USER.stores.key,
    component: Stores,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Shop, { variant: "Linear" }),
    iconActive: createIconWrapper(Shop, { variant: "Bold" }),
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
};

export const storesEdit: RouteItem = {
    name: "Stores Edit",
    id: ROUTES.USER.stores_edit.key,
    path: ROUTES.USER.stores_edit.key,
    component: Form,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
};

export const brandStores: RouteItem = {
    name: "Stores",
    id: ROUTES.USER.brand_stores.key,
    path: ROUTES.USER.brand_stores.key,
    component: BrandStores,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Shop, { variant: "Linear" }),
    iconActive: createIconWrapper(Shop, { variant: "Bold" }),
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brandStoresEdit: RouteItem = {
    name: "Stores Edit",
    id: ROUTES.USER.brand_stores_edit.key,
    path: ROUTES.USER.brand_stores_edit.key,
    component: BrandStoreForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brandStoresCreate: RouteItem = {
    name: "Stores Create",
    id: ROUTES.USER.brand_stores_create.key,
    path: ROUTES.USER.brand_stores_create.key,
    component: BrandStoreForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const singleAchievementsEdit: RouteItem = {
    name: "Single Achievements Edit",
    id: ROUTES.USER.single_achievements_edit.key,
    path: ROUTES.USER.single_achievements_edit.key,
    component: OrganizationSingleAchievementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
};

export const singleAchievementsCreate: RouteItem = {
    name: "Single Achievements Create",
    id: ROUTES.USER.single_achievements_create.key,
    path: ROUTES.USER.single_achievements_create.key,
    component: OrganizationSingleAchievementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
};

export const tieredAchievementsEdit: RouteItem = {
    name: "Missions Edit",
    id: ROUTES.USER.tiered_achievements_edit.key,
    path: ROUTES.USER.tiered_achievements_edit.key,
    component: OrganizationTieredAchivementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
};

export const tieredAchievementsCreate: RouteItem = {
    name: "Missions Create",
    id: ROUTES.USER.tiered_achievements_create.key,
    path: ROUTES.USER.tiered_achievements_create.key,
    component: OrganizationTieredAchivementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
};

export const achievements: RouteItem = {
    name: "Achievements",
    id: ROUTES.USER.achievements.key,
    path: ROUTES.USER.achievements.key,
    component: OrganizationAchievements,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Flash, { variant: "Linear" }),
    iconActive: createIconWrapper(Flash, { variant: "Bold" }),
};

export const achievementsCreate: RouteItem = {
    name: "Achievements Create",
    id: ROUTES.USER.achievements_create.key,
    path: ROUTES.USER.achievements_create.key,
    component: OrganizationAchievementsCreate,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const categories: RouteItem = {
    name: "Categories",
    id: ROUTES.USER.categories.key,
    path: ROUTES.USER.categories.key,
    component: Categories,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Flash, { variant: "Linear" }),
    iconActive: createIconWrapper(Flash, { variant: "Bold" }),
};

export const categoriesEdit: RouteItem = {
    name: "Categories Edit",
    id: ROUTES.USER.categories_edit.key,
    path: ROUTES.USER.categories_edit.key,
    component: CategoriesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const categoriesCreate: RouteItem = {
    name: "Categories Create",
    id: ROUTES.USER.categories_create.key,
    path: ROUTES.USER.categories_create.key,
    component: CategoriesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brandTags: RouteItem = {
    name: "Product Tags",
    id: ROUTES.USER.brand_tags.key,
    path: ROUTES.USER.brand_tags.key,
    component: BrandTags,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TagRight, { variant: "Linear" }),
    iconActive: createIconWrapper(TagRight, { variant: "Bold" }),
};

export const brandTagsEdit: RouteItem = {
    name: "Product Tags Edit",
    id: ROUTES.USER.brand_tags_edit.key,
    path: ROUTES.USER.brand_tags_edit.key,
    component: BrandTagsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brandTagsCreate: RouteItem = {
    name: "Product Tags Create",
    id: ROUTES.USER.brand_tags_create.key,
    path: ROUTES.USER.brand_tags_create.key,
    component: BrandTagsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const products: RouteItem = {
    name: "Products",
    id: ROUTES.USER.brand_products.key,
    path: ROUTES.USER.brand_products.key,
    component: Products,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Flash, { variant: "Linear" }),
    iconActive: createIconWrapper(Flash, { variant: "Bold" }),
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const productsEdit: RouteItem = {
    name: "Products Edit",
    id: ROUTES.USER.brand_products_edit.key,
    path: ROUTES.USER.brand_products_edit.key,
    component: ProductsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "edit",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brandHomepage: RouteItem = {
    name: "Homepage",
    id: ROUTES.USER.brand_homepage.key,
    path: ROUTES.USER.brand_homepage.key,
    component: BrandHomepage,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Menu, { variant: "Linear" }),
    iconActive: createIconWrapper(Menu, { variant: "Bold" }),
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const productsCreate: RouteItem = {
    name: "Products Create",
    id: ROUTES.USER.brand_products_create.key,
    path: ROUTES.USER.brand_products_create.key,
    component: ProductsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    props: {
        mode: "create",
    },
    hidden: true,
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const brand: RouteItem = {
    name: "Brand",
    id: ROUTES.USER.brand.key,
    path: ROUTES.USER.brand.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(PresentionChart, { variant: "Linear" }),
    iconActive: createIconWrapper(PresentionChart, { variant: "Bold" }),
    subItems: [
        brandHomepage,
        categories,
        categoriesCreate,
        categoriesEdit,
        brandTags,
        brandTagsCreate,
        brandTagsEdit,
        products,
        productsCreate,
        productsEdit,
    ],
    organizationType: [ORGANIZATION_TYPE_ENUM.BRAND],
};

export const notifications: RouteItem = {
    name: "Push Notifications",
    id: ROUTES.USER.notifications.key,
    path: ROUTES.USER.notifications.key,
    component: Notifications,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(NotificationStatus, { variant: "Linear" }),
    iconActive: createIconWrapper(NotificationStatus, { variant: "Bold" }),
};

export const notificationsEdit: RouteItem = {
    name: "Notifications Edit",
    id: ROUTES.USER.notifications_edit.key,
    path: ROUTES.USER.notifications_edit.key,
    component: Notifications,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const notificationsCreate: RouteItem = {
    name: "Promotions Create",
    id: ROUTES.USER.notifications_create.key,
    path: ROUTES.USER.notifications_create.key,
    component: NotificationsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const promotions: RouteItem = {
    name: "Promotions",
    id: ROUTES.USER.promotions.key,
    path: ROUTES.USER.promotions.key,
    component: Promotions,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Tag, { variant: "Linear" }),
    iconActive: createIconWrapper(Tag, { variant: "Bold" }),
};

export const promotionsEdit: RouteItem = {
    name: "Promotions Edit",
    id: ROUTES.USER.promotions_edit.key,
    path: ROUTES.USER.promotions_edit.key,
    component: PromotionForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const promotionsCreate: RouteItem = {
    name: "Promotions Create",
    id: ROUTES.USER.promotions_create.key,
    path: ROUTES.USER.promotions_create.key,
    component: PromotionForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const integrations: RouteItem = {
    name: "Integrations",
    id: ROUTES.USER.integrations.key,
    path: ROUTES.USER.integrations.key,
    component: Integrations,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Element4, { variant: "Linear" }),
    iconActive: createIconWrapper(Element4, { variant: "Bold" }),
};

export const integrationsEdit: RouteItem = {
    name: "Integrations Edit",
    id: ROUTES.USER.integrations_edit.key,
    path: ROUTES.USER.integrations_edit.key,
    component: IntegrationForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const aiqFlowEvents: RouteItem = {
    name: "AIQ Flow Events",
    id: ROUTES.USER.aiq_flow_events.key,
    path: ROUTES.USER.aiq_flow_events.key,
    component: AiqFlowEvents,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(CpuSetting, { variant: "Linear" }),
    iconActive: createIconWrapper(CpuSetting, { variant: "Bold" }),
};

export const aiqFlowEventsCreate: RouteItem = {
    name: "Test Event Flow",
    id: ROUTES.USER.aiq_flow_events_create.key,
    path: ROUTES.USER.aiq_flow_events_create.key,
    component: AiqFlowEventsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const sandboxTools: RouteItem = {
    name: "Sandbox Tools",
    id: ROUTES.USER.sandbox_tools.key,
    path: ROUTES.USER.sandbox_tools.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Designtools, { variant: "Linear" }),
    iconActive: createIconWrapper(Designtools, { variant: "Bold" }),
    subItems: [aiqFlowEvents],
};

export const integrationsCreate: RouteItem = {
    name: "Integrations Create",
    id: ROUTES.USER.integrations_create.key,
    path: ROUTES.USER.integrations_create.key,
    component: IntegrationForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const geofences: RouteItem = {
    name: "Geofences",
    id: ROUTES.USER.geofences.key,
    path: ROUTES.USER.geofences.key,
    component: Geofences,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Global, { variant: "Linear" }),
    iconActive: createIconWrapper(Global, { variant: "Bold" }),
};

export const geofencesEdit: RouteItem = {
    name: "Geofences Edit",
    id: ROUTES.USER.geofences_edit.key,
    path: ROUTES.USER.geofences_edit.key,
    component: GeofenceForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const geofencesCreate: RouteItem = {
    name: "Geofences Create",
    id: ROUTES.USER.geofences_create.key,
    path: ROUTES.USER.geofences_create.key,
    component: GeofenceForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const settings: RouteItem = {
    name: "Settings",
    id: ROUTES.USER.settings.key,
    path: ROUTES.USER.settings.key,
    component: OrganizationSettings,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Setting2, { variant: "Linear" }),
    iconActive: createIconWrapper(Setting2, { variant: "Bold" }),
    isSecondaryItem: true,
};

// The shared `roles` const admits Manager; the mock delivery endpoints do not.
// This mirrors the backend route group, which narrows the tenant group's
// Admin|Organization Admin|Manager|Budtender down to these two.
const deliveryRoles = ["Admin", "Organization Admin"] as any;

// A sibling of Settings rather than a child of it. Giving `settings` subItems
// would have been the tidier hierarchy, but SideBarItem renders any parent that
// has children as `<Link to="#">` whose only job is to toggle the submenu
// (SideBarItem/index.tsx:66-73) — so Settings would have stopped opening
// /settings on the first click, for every admin, to surface a QA tool.
export const deliverySettings: RouteItem = {
    name: "Mock Delivery",
    id: ROUTES.USER.delivery_settings.key,
    path: ROUTES.USER.delivery_settings.key,
    component: DeliverySettings,
    guard: AuthGuard,
    userTypes,
    roles: deliveryRoles,
    icon: createIconWrapper(Truck, { variant: "Linear" }),
    iconActive: createIconWrapper(Truck, { variant: "Bold" }),
    isSecondaryItem: true,
};

const textAndLabels: RouteItem = {
    name: "Text & Labels",
    id: ROUTES.USER.custom_content.key,
    path: ROUTES.USER.custom_content.key,
    component: CustomContent,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TextalignLeft, { variant: "Linear" }),
    iconActive: createIconWrapper(TextalignLeft, { variant: "Bold" }),
};

const haptics: RouteItem = {
    name: "Haptics",
    id: ROUTES.USER.custom_content_haptics.key,
    path: ROUTES.USER.custom_content_haptics.key,
    component: Haptics,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Mobile, { variant: "Linear" }),
    iconActive: createIconWrapper(Mobile, { variant: "Bold" }),
};

export const customContent: RouteItem = {
    name: "Custom Content",
    id: `${ROUTES.USER.custom_content.key}-parent`,
    path: ROUTES.USER.custom_content.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Notepad2, { variant: "Linear" }),
    iconActive: createIconWrapper(Notepad2, { variant: "Bold" }),
    isSecondaryItem: true,
    subItems: [textAndLabels, haptics],
};

export const organizationManagement: RouteItem = {
    name: "Organization",
    id: ROUTES.USER.organization_management.key,
    path: ROUTES.USER.organization_management.key,
    component: OrganizationManagement,
    userTypes,
    roles,
    guard: AuthGuard,
    icon: createIconWrapper(I3Dcube, { variant: "Linear" }),
    iconActive: createIconWrapper(I3Dcube, { variant: "Bold" }),
    isSecondaryItem: false,
};

export const punchcards: RouteItem = {
    name: "Punchcards",
    id: ROUTES.USER.punchcards.key,
    path: ROUTES.USER.punchcards.key,
    component: Punchcards,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(CopySuccess, { variant: "Linear" }),
    iconActive: createIconWrapper(CopySuccess, { variant: "Bold" }),
};

export const punchcardsCreate: RouteItem = {
    name: "Punchcard Create",
    id: ROUTES.USER.punchcards_create.key,
    path: ROUTES.USER.punchcards_create.key,
    component: PunchcardForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const punchcardsEdit: RouteItem = {
    name: "Punchcard Edit",
    id: ROUTES.USER.punchcards_edit.key,
    path: ROUTES.USER.punchcards_edit.key,
    component: PunchcardForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const punchcardsDashboard: RouteItem = {
    name: "Punchcard Dashboard",
    id: ROUTES.USER.punchcards_dashboard.key,
    path: ROUTES.USER.punchcards_dashboard.key,
    component: PunchcardDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const customers: RouteItem = {
    name: "Customers",
    id: ROUTES.USER.customers.key,
    path: ROUTES.USER.customers.key,
    component: Customers,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Profile2User, { variant: "Linear" }),
    iconActive: createIconWrapper(Profile2User, { variant: "Bold" }),
};

export const customersProfile: RouteItem = {
    name: "Customer Profile",
    id: ROUTES.USER.customers_profile.key,
    path: ROUTES.USER.customers_profile.key,
    component: CustomerProfile,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const rewardCategories: RouteItem = {
    name: "Reward Categories",
    id: ROUTES.USER.reward_categories.key,
    path: ROUTES.USER.reward_categories.key,
    component: RewardCategories,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Grid2, { variant: "Linear" }),
    iconActive: createIconWrapper(Grid2, { variant: "Bold" }),
};

export const rewards: RouteItem = {
    name: "Rewards",
    id: ROUTES.USER.rewards.key,
    path: ROUTES.USER.rewards.key,
    component: Rewards,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Gift, { variant: "Linear" }),
    iconActive: createIconWrapper(Gift, { variant: "Bold" }),
};

export const rewardsCreate: RouteItem = {
    name: "Reward Edit",
    id: ROUTES.USER.rewards_create.key,
    path: ROUTES.USER.rewards_create.key,
    component: RewardForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const rewardsEdit: RouteItem = {
    name: "Reward Edit",
    id: ROUTES.USER.rewards_edit.key,
    path: ROUTES.USER.rewards_edit.key,
    component: RewardForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const giftCardSettings: RouteItem = {
    name: "Gift Card Settings",
    id: ROUTES.USER.gift_card_settings.key,
    path: ROUTES.USER.gift_card_settings.key,
    component: GiftCardSettings,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Card, { variant: "Linear" }),
    iconActive: createIconWrapper(Card, { variant: "Bold" }),
};

export const microCurrencies: RouteItem = {
    name: "Micro-Currencies",
    id: ROUTES.USER.micro_currencies.key,
    path: ROUTES.USER.micro_currencies.key,
    component: MicroCurrencies,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Coin, { variant: "Linear" }),
    iconActive: createIconWrapper(Coin, { variant: "Bold" }),
};

export const microCurrenciesCreate: RouteItem = {
    name: "Micro-Currencies Create",
    id: ROUTES.USER.micro_currencies_create.key,
    path: ROUTES.USER.micro_currencies_create.key,
    component: MicroCurrenciesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const microCurrenciesEdit: RouteItem = {
    name: "Micro-Currencies Edit",
    id: ROUTES.USER.micro_currencies_edit.key,
    path: ROUTES.USER.micro_currencies_edit.key,
    component: MicroCurrenciesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const gamification: RouteItem = {
    name: "Rewards",
    id: ROUTES.USER.gamification.key,
    path: ROUTES.USER.gamification.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(ColorsSquare, { variant: "Linear" }),
    iconActive: createIconWrapper(ColorsSquare, { variant: "Bold" }),
    subItems: [rewardCategories, rewards, microCurrencies, giftCardSettings],
};


export const coupons: RouteItem = {
    name: "Coupons",
    id: ROUTES.USER.coupons.key,
    path: ROUTES.USER.coupons.key,
    component: Coupons,
    guard: AuthGuard,
    userTypes,
    roles,
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
    icon: createIconWrapper(TicketStar, { variant: "Linear" }),
    iconActive: createIconWrapper(TicketStar, { variant: "Bold" }),
};

export const couponsCreate: RouteItem = {
    name: "Coupons Create",
    id: ROUTES.USER.coupons_create.key,
    path: ROUTES.USER.coupons_create.key,
    component: CouponsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
    hidden: true,
    props: {
        mode: "create",
    },
};

export const couponsEdit: RouteItem = {
    name: "Coupons Edit",
    id: ROUTES.USER.coupons_edit.key,
    path: ROUTES.USER.coupons_edit.key,
    component: CouponsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const referralReport: RouteItem = {
    name: "Referrals",
    id: ROUTES.USER.referral_report.key,
    path: ROUTES.USER.referral_report.key,
    component: ReferralsReport,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TagUser, { variant: "Linear" }),
    iconActive: createIconWrapper(TagUser, { variant: "Bold" }),
};

export const achievementsEarnedReport: RouteItem = {
    name: "Achievements Earned",
    id: ROUTES.USER.achievements_earned_report.key,
    path: ROUTES.USER.achievements_earned_report.key,
    component: AchievementsEarnedReport,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(FlashCircle, { variant: "Linear" }),
    iconActive: createIconWrapper(FlashCircle, { variant: "Bold" }),
};

export const userRegistrationReport: RouteItem = {
    name: "User Registrations",
    id: ROUTES.USER.user_registration_report.key,
    path: ROUTES.USER.user_registration_report.key,
    component: UserRegistrationReport,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(UserAdd, { variant: "Linear" }),
    iconActive: createIconWrapper(UserAdd, { variant: "Bold" }),
};

export const reports: RouteItem = {
    name: "Reports",
    id: ROUTES.USER.reports.key,
    path: ROUTES.USER.reports.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(PresentionChart, { variant: "Linear" }),
    iconActive: createIconWrapper(PresentionChart, { variant: "Bold" }),
    subItems: [
        referralReport,
        userRegistrationReport,
        achievementsEarnedReport,
    ],
};

export const orders: RouteItem = {
    name: "Orders",
    id: ROUTES.USER.orders.key,
    path: ROUTES.USER.orders.key,
    component: TenantOrders,
    guard: AuthGuard,
    userTypes,
    roles: orderRoles,
    organizationType: [ORGANIZATION_TYPE_ENUM.DISPENSARY],
    icon: createIconWrapper(BagTick, { variant: "Linear" }),
    iconActive: createIconWrapper(BagTick, { variant: "Bold" }),
};

export const gamesPage: RouteItem = {
    name: "Games",
    id: ROUTES.USER.games.key,
    path: ROUTES.USER.games.key,
    component: Games,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Game, { variant: "Linear" }),
    iconActive: createIconWrapper(Game, { variant: "Bold" }),
};

export const gamesCreate: RouteItem = {
    name: "Games Create",
    id: ROUTES.USER.games_create.key,
    path: ROUTES.USER.games_create.key,
    component: GamesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const gamesEdit: RouteItem = {
    name: "Games Edit",
    id: ROUTES.USER.games_edit.key,
    path: ROUTES.USER.games_edit.key,
    component: GamesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const gamesDashboard: RouteItem = {
    name: "Games Dashboard",
    id: ROUTES.USER.games_dashboard.key,
    path: ROUTES.USER.games_dashboard.key,
    component: GamesDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const gameEntries: RouteItem = {
    name: "Game Entries",
    id: ROUTES.USER.game_entries.key,
    path: ROUTES.USER.game_entries.key,
    component: GameEntries,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Receipt21, { variant: "Linear" }),
    iconActive: createIconWrapper(Receipt21, { variant: "Bold" }),
};

export const gameEntriesCreate: RouteItem = {
    name: "Game Entries Create",
    id: ROUTES.USER.game_entries_create.key,
    path: ROUTES.USER.game_entries_create.key,
    component: GameEntriesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const games: RouteItem = {
    name: "Games",
    id: ROUTES.USER.games.key,
    path: ROUTES.USER.games.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Game, { variant: "Linear" }),
    iconActive: createIconWrapper(Game, { variant: "Bold" }),
    subItems: [
        gamesPage,
        gamesCreate,
        gamesEdit,
        gamesDashboard,
        gameEntries,
        gameEntriesCreate,
    ],
};

export const analytics: RouteItem = {
    name: "Analytics",
    id: ROUTES.USER.analytics.key,
    path: ROUTES.USER.analytics.key,
    guard: AuthGuard,
    isExternal: true,
    userTypes,
    roles,
    icon: createIconWrapper(Chart1, { variant: "Linear" }),
    iconActive: createIconWrapper(Chart1, { variant: "Bold" }),
};

export const downloadLinks: RouteItem = {
    name: "Download Links",
    id: ROUTES.USER.download_links.key,
    path: ROUTES.USER.download_links.key,
    component: DownloadLinks,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Link1, { variant: "Linear" }),
    iconActive: createIconWrapper(Link1, { variant: "Bold" }),
};

export const downloadLinksCreate: RouteItem = {
    name: "Download Links Create",
    id: ROUTES.USER.download_links_create.key,
    path: ROUTES.USER.download_links_create.key,
    component: DownloadLinksForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const downloadLinksEdit: RouteItem = {
    name: "Download Links Edit",
    id: ROUTES.USER.download_links_edit.key,
    path: ROUTES.USER.download_links_edit.key,
    component: DownloadLinksForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const inAppQRCodes: RouteItem = {
    name: "In-app QR Codes",
    id: ROUTES.USER.in_app_qr_codes.key,
    path: ROUTES.USER.in_app_qr_codes.key,
    component: InAppQRCodes,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(ScanBarcode, { variant: "Linear" }),
    iconActive: createIconWrapper(ScanBarcode, { variant: "Bold" }),
};

export const inAppQRCodesCreate: RouteItem = {
    name: "In-app QR Codes Create",
    id: ROUTES.USER.in_app_qr_codes_create.key,
    path: ROUTES.USER.in_app_qr_codes_create.key,
    component: InAppQRCodesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const inAppQRCodesEdit: RouteItem = {
    name: "In-app QR Codes Edit",
    id: ROUTES.USER.in_app_qr_codes_edit.key,
    path: ROUTES.USER.in_app_qr_codes_edit.key,
    component: InAppQRCodesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const qrCodes: RouteItem = {
    name: "QR Codes",
    id: ROUTES.USER.qr_codes.key,
    path: ROUTES.USER.qr_codes.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(ScanBarcode, { variant: "Linear" }),
    iconActive: createIconWrapper(ScanBarcode, { variant: "Bold" }),
    subItems: [
        downloadLinks,
        downloadLinksCreate,
        downloadLinksEdit,
        inAppQRCodes,
        inAppQRCodesCreate,
        inAppQRCodesEdit,
    ],
};

export const appFeedbacks: RouteItem = {
    name: "App Feedbacks",
    id: ROUTES.USER.app_feedbacks.key,
    path: ROUTES.USER.app_feedbacks.key,
    component: AppFeedbacks,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Message, { variant: "Linear" }),
    iconActive: createIconWrapper(Message, { variant: "Bold" }),
};

export const tiers: RouteItem = {
    name: "Tiers",
    id: ROUTES.USER.tiers.key,
    path: ROUTES.USER.tiers.key,
    component: TiersPage,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Diamonds, { variant: "Linear" }),
    iconActive: createIconWrapper(Diamonds, { variant: "Bold" }),
};

export const tiersCreate: RouteItem = {
    name: "Tiers Create",
    id: ROUTES.USER.tiers_create.key,
    path: ROUTES.USER.tiers_create.key,
    component: TiersFormView,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const tiersEdit: RouteItem = {
    name: "Tiers Edit",
    id: ROUTES.USER.tiers_edit.key,
    path: ROUTES.USER.tiers_edit.key,
    component: TiersFormView,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const sweepstakes: RouteItem = {
    name: "Sweepstakes",
    id: ROUTES.USER.sweepstakes.key,
    path: ROUTES.USER.sweepstakes.key,
    component: Sweepstakes,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Ticket, { variant: "Linear" }),
    iconActive: createIconWrapper(Ticket, { variant: "Bold" }),
};

export const sweepstakesCreate: RouteItem = {
    name: "Sweepstakes Create",
    id: ROUTES.USER.sweepstakes_create.key,
    path: ROUTES.USER.sweepstakes_create.key,
    component: SweepstakesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const sweepstakesEdit: RouteItem = {
    name: "Sweepstakes Edit",
    id: ROUTES.USER.sweepstakes_edit.key,
    path: ROUTES.USER.sweepstakes_edit.key,
    component: SweepstakesForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const sweepstakesDashboard: RouteItem = {
    name: "Sweepstakes Dashboard",
    id: ROUTES.USER.sweepstakes_dashboard.key,
    path: ROUTES.USER.sweepstakes_dashboard.key,
    component: SweepstakesDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const customTags: RouteItem = {
    name: "Tags",
    id: ROUTES.USER.tags.key,
    path: ROUTES.USER.tags.key,
    component: CustomTags,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TagRight, { variant: "Linear" }),
    iconActive: createIconWrapper(TagRight, { variant: "Bold" }),
};

export const customTagsCreate: RouteItem = {
    name: "Tags Create",
    id: ROUTES.USER.tags_create.key,
    path: ROUTES.USER.tags_create.key,
    component: CustomTagsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const customTagsEdit: RouteItem = {
    name: "Tags Edit",
    id: ROUTES.USER.tags_edit.key,
    path: ROUTES.USER.tags_edit.key,
    component: CustomTagsForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const brandBoosts: RouteItem = {
    name: "Brand Boosts",
    id: ROUTES.USER.brand_boosts.key,
    path: ROUTES.USER.brand_boosts.key,
    component: BrandBoosts,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(FavoriteChart, { variant: "Linear" }),
    iconActive: createIconWrapper(FavoriteChart, { variant: "Bold" }),
};

export const engagement: RouteItem = {
    name: "Engagement engine",
    id: ROUTES.USER.engagement.key,
    path: ROUTES.USER.engagement.key,
    component: Engagement,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Send2, { variant: "Linear" }),
    iconActive: createIconWrapper(Send2, { variant: "Bold" }),
};

export const engagementCreate: RouteItem = {
    name: "Engagement Create",
    id: ROUTES.USER.engagement_create.key,
    path: ROUTES.USER.engagement_create.key,
    component: EngagementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "create",
    },
};

export const engagementEdit: RouteItem = {
    name: "Engagement Edit",
    id: ROUTES.USER.engagement_edit.key,
    path: ROUTES.USER.engagement_edit.key,
    component: EngagementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
    props: {
        mode: "edit",
    },
};

export const engagementDetail: RouteItem = {
    name: "Engagement Detail",
    id: ROUTES.USER.engagement_detail.key,
    path: ROUTES.USER.engagement_detail.key,
    component: EngagementDetail,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const userRoutes: RouteItem[] = [
    overview,
    stores,
    storesEdit,
    brandStores,
    brandStoresEdit,
    brandStoresCreate,
    singleAchievementsEdit,
    singleAchievementsCreate,
    tieredAchievementsEdit,
    tieredAchievementsCreate,
    achievements,
    achievementsCreate,
    brand,
    notifications,
    notificationsEdit,
    notificationsCreate,
    promotions,
    promotionsEdit,
    promotionsCreate,
    integrations,
    integrationsCreate,
    integrationsEdit,
    sandboxTools,
    aiqFlowEventsCreate,
    geofences,
    geofencesCreate,
    geofencesEdit,
    punchcards,
    punchcardsCreate,
    punchcardsEdit,
    punchcardsDashboard,
    customers,
    customersProfile,
    coupons,
    couponsCreate,
    couponsEdit,
    gamification,
    rewardsCreate,
    rewardsEdit,
    microCurrenciesCreate,
    microCurrenciesEdit,
    settings,
    deliverySettings,
    customContent,
    organizationManagement,
    orders,
    games,
    qrCodes,
    reports,
    analytics,
    appFeedbacks,
    tiers,
    tiersCreate,
    tiersEdit,
    sweepstakes,
    sweepstakesCreate,
    sweepstakesEdit,
    sweepstakesDashboard,
    customTags,
    customTagsCreate,
    customTagsEdit,
    brandBoosts,
    engagement,
    engagementCreate,
    engagementEdit,
    engagementDetail,
];

export const dispensaryBudtenderRoutes: RouteItem[] = [
    orders,
    customers,
    customersProfile,
];